import bezierEasing from './bezier-easing';
export function stopTouch(e) {
    e.cancelable && e.preventDefault();
}
export function preventEleScroll(scrollContainer, preventWindow, customStopTouch) {
    if (scrollContainer === void 0) { scrollContainer = function () { return document.body; }; }
    var element = scrollContainer();
    if (!element) {
        return;
    }
    element.style.overflow = 'hidden';
    element.style.touchAction = 'none';
    var preEle = preventWindow ? window : element;
    preEle.addEventListener('touchmove', customStopTouch || stopTouch, {
        passive: false,
        capture: true,
    });
}
export function freeEleScroll(scrollContainer, preventWindow, customStopTouch) {
    if (scrollContainer === void 0) { scrollContainer = function () { return document.body; }; }
    var element = scrollContainer();
    if (!element) {
        return;
    }
    element.style.overflow = '';
    element.style.touchAction = '';
    var preEle = preventWindow ? window : element;
    preEle.removeEventListener('touchmove', customStopTouch || stopTouch, { capture: true });
}
/**
 * 判断父节点是否包含子节点
 * @param parentEl 父节点
 * @param childrenEl 子节点
 */
export var isContains = function (parentEl, childrenEl) {
    if (!parentEl || !childrenEl)
        return false;
    if (parentEl.contains) {
        return parentEl.contains(childrenEl);
    }
    var parent = childrenEl;
    while (parent) {
        if (parentEl === parent) {
            return true;
        }
        parent = parent.parentNode;
    }
    return false;
};
export function execRAF(fn) {
    try {
        return requestAnimationFrame(fn);
    }
    catch (e) {
        return setTimeout(fn, 17);
    }
}
export function scrollWithAnimation(initTop, target, scrollTo, duration, bezier, type) {
    if (duration === void 0) { duration = 300; }
    if (bezier === void 0) { bezier = [0.34, 0.69, 0.1, 1]; }
    if (type === void 0) { type = 'to'; }
    var targetTop = Math.max(0, type === 'by' ? initTop + target : target);
    var start = Date.now();
    var fn = function () {
        var p = (Date.now() - start) / duration;
        if (p > 1) {
            scrollTo(targetTop);
        }
        else {
            var newTop = initTop + (targetTop - initTop) * bezierEasing.apply(void 0, bezier)(p);
            scrollTo(newTop);
            execRAF(fn);
        }
    };
    execRAF(fn);
}
/**
 * 返回节点的 document 对象属性
 * @param {HTMLElement} node dom 节点
 */
export function scrollParent(node) {
    var excludeStaticParent = node.style.position === 'absolute';
    var overflowList = ['scroll', 'auto'];
    var parent = node;
    while (parent) {
        if (!parent.parentNode) {
            return node.ownerDocument || document.documentElement;
        }
        var style = window.getComputedStyle(parent);
        var position = style.position;
        // const overflow = style.overflow || '';
        var overflowX = style.overflowX || '';
        var overflowY = style.overflowY || '';
        if (position === 'static' && excludeStaticParent) {
            parent = parent.parentNode;
            continue;
        }
        // TODO: 不确定是否有坑，先保留注释
        if (overflowList.indexOf(overflowY) > -1 ||
            overflowList.indexOf(overflowX) > -1
        // && overflowList.indexOf(overflow) > -1
        ) {
            return parent;
        }
        parent = parent.parentNode;
    }
    return node.ownerDocument || document.documentElement;
}
/**
 * 获得元素 offset
 * @param {HTMLElement} node dom 节点
 */
export function getOffset(node) {
    var _a;
    var top, height;
    if (node instanceof HTMLElement) {
        (_a = node.getBoundingClientRect() || { height: 0, top: 0 }, height = _a.height, top = _a.top);
    }
    else {
        top = 0;
        height = 0;
    }
    return {
        height: height,
        top: top,
    };
}
/**
 * 检查 overflow 为 scroll 或 auto 时，元素是否在视口区域内
 * @param component 当前元素节点
 * @param parent 当前元素所在容器 dom 节点
 */
export function checkOverflowVisible(component, parent) {
    var node = component.node, offset = component.offset, threshold = component.threshold;
    var _a = getOffset(parent), parentTop = _a.top, parentHeight = _a.height;
    var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
    var intersectionTop = Math.max(parentTop, 0);
    var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop;
    var _b = getOffset(node), top = _b.top, elementHeight = _b.height;
    var offsetTop = top - intersectionTop;
    var offsets = Array.isArray(offset) ? offset : [offset, offset];
    var thresholdHeight = elementHeight * threshold;
    return (offsetTop - offsets[1] + thresholdHeight <= intersectionHeight &&
        offsetTop + elementHeight + offsets[0] >= 0 + thresholdHeight);
}
/**
 * 检查非局部滚动容器元素是否在视口区域内
 * @param component 当前元素节节点
 */
export function checkNormalVisible(component) {
    var node = component.node, offset = component.offset, threshold = component.threshold;
    if (!(node instanceof HTMLElement)) {
        return false;
    }
    if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) {
        return false;
    }
    var _a = getOffset(node), top = _a.top, elementHeight = _a.height;
    var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
    var thresholdHeight = elementHeight * threshold;
    var offsets = Array.isArray(offset) ? offset : [offset, offset];
    return (top - offsets[1] + thresholdHeight <= windowInnerHeight &&
        top + elementHeight + offsets[0] >= 0 + thresholdHeight);
}
/**
 * 根据id动态添加dom元素
 * @param id 添加的dom id
 * @param getContainer 被添加元素的父级
 */
export function appendElementById(id, getContainer) {
    var div = document.querySelector("#" + id) || document.createElement('div');
    div.id = id;
    var container = getContainer && getContainer() ? getContainer() : document.body;
    container.appendChild(div);
    return {
        child: div,
        container: container,
    };
}
/**
 * 从父级节点移除元素
 * @param ele 待移除元素
 */
export function removeElement(ele) {
    if (ele && ele.parentNode) {
        ele.parentNode.removeChild(ele);
    }
}
export function getActualContainer(getContainer) {
    var container = getContainer ? getContainer() : void 0;
    return typeof container === 'string'
        ? document.querySelector(container)
        : container;
}
export function getValidScrollContainer(getContainer) {
    var originContainer = getContainer ? getContainer() : window; // 默认为window
    // body的滚动在window上监听，document.body.addEventListener('scroll') 是不生效的
    return originContainer === document.body ? window : originContainer;
}
export function getScrollContainerAttribute(property, getContainer) {
    var container = getContainer ? getContainer() : window;
    if (!container)
        return 0;
    if (container === window || container === document) {
        return document.documentElement[property] || document.body[property];
    }
    if (container === document.body) {
        return document.body[property] || document.documentElement[property];
    }
    return container[property];
}
export function getScrollContainerRect(container) {
    if (!container) {
        return {
            isGlobal: false,
            scrollEle: container,
            containerRect: { top: 0, left: 0, bottom: 0, right: 0 },
        };
    }
    var scrollEle = container === window ? document.documentElement : container;
    var isGlobal = scrollEle === document.documentElement || scrollEle === document.body;
    // html和body内部滚动时，DOMRect.top会变，此时需求是取相对于视口的top值，因此top直接设置为0
    var containerRect = isGlobal
        ? {
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            right: window.innerWidth,
        }
        : scrollEle.getBoundingClientRect();
    return { isGlobal: isGlobal, scrollEle: scrollEle, containerRect: containerRect };
}
export var styleDoms = {};
export function removeCssStyleDom(key) {
    var styleDom = styleDoms[key];
    if (styleDom) {
        document.documentElement.removeChild(styleDom);
        delete styleDoms[key];
    }
}
export function addCssStyleDom(key, html) {
    removeCssStyleDom(key);
    var style = document.createElement('style');
    style.innerHTML = html;
    document.documentElement.appendChild(style);
    styleDoms[key] = style;
}
export function addCssKeyframes(key, rules) {
    addCssStyleDom(key, "@keyframes " + key + " " + rules + "\n@-webkit-keyframes " + key + " " + rules);
}
export function addCssRules(key, rules) {
    if (!rules || !Object.keys(rules).length) {
        return;
    }
    addCssStyleDom(key, ":root {" + Object.keys(rules)
        .map(function (rule) { return "--" + rule + ": " + rules[rule] + ";"; })
        .join('\n') + "}");
}
/**
 * @description 不同机型下的字体大小与标准字体大小的比率，计算类似.rem()
 * @param {Number} px  待处理像素值
 * @param {Number} baseFontSize 基准字号
 * @returns {String} 计算后的像素值
 */
export function getActualPixel(px, baseFontSize) {
    if (baseFontSize === void 0) { baseFontSize = 50; }
    var htmlDOM = document.getElementsByTagName('html')[0];
    var htmlFontSize = htmlDOM.style.fontSize;
    var fontSize = baseFontSize;
    if (htmlFontSize.indexOf('%') !== -1) {
        // 百分比类型
        fontSize = parseFloat(getComputedStyle(htmlDOM).fontSize.replace('px', ''));
    }
    else if (htmlFontSize.indexOf('px') !== -1) {
        // px 类型
        fontSize = parseFloat(htmlFontSize.replace('px', '')) || baseFontSize;
    }
    var fontSizeRadio = fontSize / baseFontSize;
    return px * fontSizeRadio;
}
